import { createStyles, makeStyles } from '@material-ui/core/styles';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        closeButton: {
            marginRight: `-${theme.spacing(1)}px`,
        },
    });
};

export default makeStyles(styles, { name: 'MuiDialogClose' });
